import { SortPartSerializerr929bckmbnab as SortPartSerializer } from './SortPartSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_compareitb8kqyvdfgc as get_compare } from './DataClassPath.sort.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { compareTo27a9ghv6nck15 as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (SortPartSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SortPartClass;
function SortPart() {
  if (SortPartClass === VOID) {
    class $ {
      constructor(field, ascending, ignoreCase) {
        ascending = ascending === VOID ? true : ascending;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        this.field_1 = field;
        this.ascending_1 = ascending;
        this.ignoreCase_1 = ignoreCase;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        if (!this.ascending_1) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(45));
        }
        if (this.ignoreCase_1) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(126));
        }
        this_0.append_22ad7x_k$(this.field_1.toString());
        return this_0.toString();
      }
      hashCode() {
        var result = this.field_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.ascending_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.ignoreCase_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SortPart()))
          return false;
        if (!this.field_1.equals(other.field_1))
          return false;
        if (!(this.ascending_1 === other.ascending_1))
          return false;
        if (!(this.ignoreCase_1 === other.ignoreCase_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SortPart', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    SortPartClass = $;
  }
  return SortPartClass;
}
function get_comparator(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    return null;
  var tmp = (a, b) => {
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var part = _iterator__ex2g4s.next_20eer_k$();
      if (part.ignoreCase_1 && equals(part.field_1.get_serializerAny_e3t5u9_k$().get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), STRING_getInstance())) {
        var tmp = part.field_1.getAny_nwh1wi_k$(a);
        var aString = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
        var tmp_0 = part.field_1.getAny_nwh1wi_k$(b);
        var bString = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
        var result = compareTo(aString, bString, true);
        if (!(result === 0))
          return part.ascending_1 ? result : -result | 0;
      } else {
        var result_0 = get_compare(part.field_1).compare(a, b);
        if (!(result_0 === 0))
          return part.ascending_1 ? result_0 : -result_0 | 0;
      }
    }
    return 0;
  };
  return new (sam$kotlin_Comparator$0())(tmp);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  SortPart as SortParte7ewatwctfe4,
  get_comparator as get_comparatornh5qvtuce91z,
  Companion_instance as Companion_instance3giyawr5ckwev,
};
//endregion

//# sourceMappingURL=SortPart.mjs.map
